module.exports = __webpack_public_path__ + "media/components/shared/static/arrow_prev-dark-a2863a1d72c0c323a07526f1134919ae.svg";